<template>
	<transition
			appear
			:appear-active-class="$_inpCmbMlt_styleInputComboboxMulitpleAnimation()">
		<v-row no-gutters>
			<v-col>
				<validation-provider
						:name="'InputComboboxMultiple-' + contentKey"
						:rules="getValidationRules(contents[contentKey].rules)"
						v-slot="{ errors }">
					<v-combobox 
							v-model="$store.state.input.data[contentKey].answer"
					
							multiple
							return-object

							:background-color="$_inpCmbMlt_styleComboboxMultipleBackgroundColor"
							:chips="$_inpCmbMlt_styleComboboxMultipleChips"
							:clearable="$_inpCmbMlt_styleComboboxMultipleClearable"
							:color="$_inpCmbMlt_styleComboboxMultipleColor"
							:deletable-chips="$_inpCmbMlt_styleComboboxMultipleDeletableChips"
							:dark="$_inpCmbMlt_styleComboboxMultipleDark"
							:dense="$_inpCmbMlt_styleComboboxMultipleDense"
							:filled="$_inpCmbMlt_styleComboboxMultipleFilled"
							:flat="$_inpCmbMlt_styleComboboxMultipleFlat"
							:light="$_inpCmbMlt_styleComboboxMultipleLight"
							:outlined="$_inpCmbMlt_styleComboboxMultipleOutlined"
							:small-chips="$_inpCmbMlt_styleComboboxMultipleSmallChips"
							:solo="$_inpCmbMlt_styleComboboxMultipleSolo"
							:solo-inverted="$_inpCmbMlt_styleComboboxMultipleSoloInverted"

							:append-icon="$_inpCmbMlt_styleParamAppendIcon(contents[contentKey].params)"
							:append-outer-icon="$_inpCmbMlt_styleParamAppendOuterIcon(contents[contentKey].params)"
							:prepend-icon="$_inpCmbMlt_styleParamPrependIcon(contents[contentKey].params)"
							:prepend-inner-icon="$_inpCmbMlt_styleParamPrependInnerIcon(contents[contentKey].params)"

							:hint="$_inpCmbMlt_langParamHint(contents[contentKey].params)"
							:mask="$_inpCmbMlt_langParamMask(contents[contentKey].params)"
							:message="$_inpCmbMlt_langParamMessage(contents[contentKey].params)"
							:placeholder="$_inpCmbMlt_langParamPlaceholder(contents[contentKey].params)"
							:prefix="$_inpCmbMlt_langParamPrefix(contents[contentKey].params)"
							:suffix="$_inpCmbMlt_langParamSuffix(contents[contentKey].params)"
							:type="$_inpCmbMlt_langParamType(contents[contentKey].params)"

							item-avater="icon"
							item-text="text"
							item-value="key"
							:items="arrayObject(contents[contentKey].options)"

							:error-messages="errors" />
				</validation-provider>
			</v-col>
		</v-row>
	</transition>
</template>

<script>
	export default {
		name: 'InputComboboxMultiple',
		props: {
			contentKey: String,
			contents: Object,
			inits: Object
		},
		computed: {
			// lang
			$_inpCmbMlt_langParamHint() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.hint;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			$_inpCmbMlt_langParamMask() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.mask;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			$_inpCmbMlt_langParamMessage() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.message;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			$_inpCmbMlt_langParamPlaceholder() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.placeholder;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			$_inpCmbMlt_langParamPrefix() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.prefix;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			$_inpCmbMlt_langParamSuffix() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.suffix;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			$_inpCmbMlt_langParamType() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.type;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			// style
			$_inpCmbMlt_styleInputComboboxMulitple() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.inits)) { return null }
					return self_.getInitsStyleVal(self_.inits, 'inputComboboxMultiple')
				}
			},
			$_inpCmbMlt_styleInputComboboxMulitpleAnimation() {
				const self_ = this;
				return () => {
					const layout_ = self_.$_inpCmbMlt_styleInputComboboxMulitple()
					if(self_.isFalse(layout_)) { return null }
					return self_.getStylesVal(layout_.animation)
				}
			},
			$_inpCmbMlt_styleComboboxMultiple() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'comboboxMultiple')
			},
			$_inpCmbMlt_styleComboboxMultipleBackgroundColor() {
				const self_ = this;
				const style_ = self_.$_inpCmbMlt_styleComboboxMultiple;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.backgroundColor)
			},
			$_inpCmbMlt_styleComboboxMultipleChips() {
				const self_ = this;
				const style_ = self_.$_inpCmbMlt_styleComboboxMultiple;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.chips)
			},
			$_inpCmbMlt_styleComboboxMultipleClearable() {
				const self_ = this;
				const style_ = self_.$_inpCmbMlt_styleComboboxMultiple;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.clearable)
			},
			$_inpCmbMlt_styleComboboxMultipleColor() {
				const self_ = this;
				const style_ = self_.$_inpCmbMlt_styleComboboxMultiple;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.color)
			},
			$_inpCmbMlt_styleComboboxMultipleDeletableChips() {
				const self_ = this;
				const style_ = self_.$_inpCmbMlt_styleComboboxMultiple;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.deletableChips)
			},
			$_inpCmbMlt_styleComboboxMultipleDark() {
				const self_ = this;
				const style_ = self_.$_inpCmbMlt_styleComboboxMultiple;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.dark)
			},
			$_inpCmbMlt_styleComboboxMultipleDense() {
				const self_ = this;
				const style_ = self_.$_inpCmbMlt_styleComboboxMultiple;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.dense)
			},
			$_inpCmbMlt_styleComboboxMultipleFilled() {
				const self_ = this;
				const style_ = self_.$_inpCmbMlt_styleComboboxMultiple;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.filled)
			},
			$_inpCmbMlt_styleComboboxMultipleFlat() {
				const self_ = this;
				const style_ = self_.$_inpCmbMlt_styleComboboxMultiple;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.flat)
			},
			$_inpCmbMlt_styleComboboxMultipleLight() {
				const self_ = this;
				const style_ = self_.$_inpCmbMlt_styleComboboxMultiple;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.light)
			},
			$_inpCmbMlt_styleComboboxMultipleOutlined() {
				const self_ = this;
				const style_ = self_.$_inpCmbMlt_styleComboboxMultiple;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.outlined)
			},
			$_inpCmbMlt_styleComboboxMultipleSmallChips() {
				const self_ = this;
				const style_ = self_.$_inpCmbMlt_styleComboboxMultiple;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.smallChips)
			},
			$_inpCmbMlt_styleComboboxMultipleSolo() {
				const self_ = this;
				const style_ = self_.$_inpCmbMlt_styleComboboxMultiple;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.solo)
			},
			$_inpCmbMlt_styleComboboxMultipleSoloInverted() {
				const self_ = this;
				const style_ = self_.$_inpCmbMlt_styleComboboxMultiple;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.soloInverted)
			},
			$_inpCmbMlt_styleParamAppendIcon() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.appendIcon;
					if(self_.isFalse(param_)) { return null }
					return self_.getStylesVal(param_)
				}
			},
			$_inpCmbMlt_styleParamAppendOuterIcon() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.appendOuterIcon;
					if(self_.isFalse(param_)) { return null }
					return self_.getStylesVal(param_)
				}
			},
			$_inpCmbMlt_styleParamPrependIcon() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.prependIcon;
					if(self_.isFalse(param_)) { return null }
					return self_.getStylesVal(param_)
				}
			},
			$_inpCmbMlt_styleParamPrependInnerIcon() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.prependInnerIcon;
					if(self_.isFalse(param_)) { return null }
					return self_.getStylesVal(param_)
				}
			}
		}
	}
</script>

<style scoped>
</style>
